module.exports = angular.module(__filename, [])
  .service('audienceExplorerExportService', [ 'Excel', 'segmentInterestExportService', function (Excel, segmentInterestExportService) {

    function createCategoriesWorksheet(workbook, categories, formatter, sheetName = 'Audience Affinities', includeSizeAndId = true) {
      const worksheet = workbook.createWorksheet({name: sheetName});

      const titleLine = [
          formatter('Category Name', 'bold'),
          formatter('Category Taxonomy', 'bold'),
          ...(includeSizeAndId ? [formatter('Category Description', 'bold')] : []),
          formatter('Audience Skew', 'bold'),
          formatter('Category Portion In Audience', 'bold'),
          formatter('Audience Portion In Category', 'bold'),
          ...(includeSizeAndId ? [formatter('Category Size', 'bold'), formatter('DMP Category ID', 'bold')] : [])
      ];

      // Sort categories by audience skew (uniqueness-index) descending
      const sortedCategories = _.orderBy(categories, ['uniqueness-index'], ['desc']);

      const data = sortedCategories.map(category => [
          category.phrase,
          category.path.join(' > '),
          ...(includeSizeAndId ? [category.description || ''] : []),
          formatter(category['uniqueness-index'] || 0, 'numeric'),
          formatter((category['interest-portion'] || 0) / 100, 'percent'),
          formatter((category['segment-portion'] || 0) / 100, 'percent'),
          ...(includeSizeAndId ? [formatter(category.reach || 0, 'short_integer', 0), category.id || ''] : [])
      ]);

      data.unshift(titleLine);
      worksheet.setData(data);
      worksheet.setColumns([
          {width: 35}, // Category Name
          {width: 75}, // Category Taxonomy
          ...(includeSizeAndId ? [{width: 115}] : []), // Category Description
          {width: 14}, // Audience Skew
          {width: 25}, // Consumption In Audience
          {width: 25}, // Audience Portion In Consumption
          ...(includeSizeAndId ? [{width: 13}, {width: 16}] : []) // Category Reach, Category ID
      ]);
      workbook.addWorksheet(worksheet);
  }

    function createTvShowsWorksheet(workbook, interests, formatter, title, filteredByNetworks = []) {
      const worksheet = workbook.createWorksheet({name: title});

      const titleLine = [
        formatter(title.slice(0, title.lastIndexOf('s')), 'bold'),
        formatter('Consumption In Audience', 'bold'),
        formatter('Audience Portion In Consumption', 'bold'),
        formatter('Audience Skew', 'bold'),
        formatter('Significance Score', 'bold')
      ];

      let data = interests.map(interest => {
        const arr = [
          formatter(interest.title, 'normal'),
          formatter(interest['interest-portion'] / 100, 'percent'),
          formatter(interest['segment-portion'] / 100, 'percent'),
          formatter(interest['uniqueness-index'], 'numeric'),
          formatter(interest['score'], 'numeric')
        ];
        return arr;
      });

      data.unshift(titleLine);

      let filteredByNetworksFormatted = [formatter('Filtered By Networks', 'bold')].concat(filteredByNetworks.map(network => formatter(network.label, 'normal')));
      worksheet.setData(_.isEmpty(filteredByNetworks) ? data : Excel.insertDataAtColumn(data, filteredByNetworksFormatted, titleLine.length + 2));
      const columnWidths = [20, 18, 18, 18, 18, 15, 20, 12, 20];
      worksheet.setColumns(_.map(columnWidths, (width) => ({ width })));
      workbook.addWorksheet(worksheet);
    }

    function momentBasedFileNamerGen(baseName, extension = 'xlsx') {
      return `${baseName} ${moment().toString()}.${extension}`;
    }

    function exportToExcel(tvShowsExportData, audienceInterestExportData, mutualExportData, showTvTab) {
      const {segment, demographicsData, channel} = mutualExportData;
      const {topics, websites, phrases, searches, categories, purchaseAffinities} = audienceInterestExportData;
      const workbook = segmentInterestExportService.exportToExcel(topics, websites, phrases, searches, segment, demographicsData, channel);
      const formatter = Excel.formater(workbook);

      if(showTvTab) {
        const {data, withNetworks, filteredByNetworks} = tvShowsExportData;
        createTvShowsWorksheet(workbook, data?.tv || [], formatter, 'TV Shows', filteredByNetworks);
        createTvShowsWorksheet(workbook, data?.genres || [], formatter, 'Genres', filteredByNetworks);
        if (withNetworks) createTvShowsWorksheet(workbook, data?.networks || [], formatter, 'Networks');
        workbook.fileName = momentBasedFileNamerGen('Audience Exploration');
      }
      if (purchaseAffinities && purchaseAffinities.length > 0) createCategoriesWorksheet(workbook, purchaseAffinities, formatter, 'Purchase Affinities', false);
      if (categories && categories.length > 0) createCategoriesWorksheet(workbook, categories, formatter, 'Audience Affinities');

      return workbook;
    }

    return {
      exportToExcel
    };
    }]
  );
